import { Platform } from "react-native";
import { fetchHttpPost } from "@lookiero/sty-psp-http";
import { VERSION } from "../../version";
import { getGame, saveGame } from "../domain/game/model/httpGames";
import { httpGameByCustomerIdView } from "../projection/game/httpGameByCustomerIdView";
import { baseBootstrap } from "./baseBootstrap";
const device = Platform.OS;
const bootstrap = ({ apiUrl, getAuthToken }) => {
    const httpPost = fetchHttpPost({ apiUrl, getAuthToken, device, version: VERSION });
    return baseBootstrap({
        gameByCustomerIdView: httpGameByCustomerIdView({ httpPost }),
        getGame,
        saveGame,
        gamesDependencies: [{ httpPost }],
    });
};
export { bootstrap };
